import { ReactElement, SVGProps } from 'react'
export const SvgRutube = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#rutube_svg__a)">
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
        fill="#303030"
      />
      <path
        d="M19.786 10.362H9V22h3.002v-3.786h5.753L20.38 22h3.361l-2.894-3.803c.899-.14 1.546-.472 1.941-.995.396-.524.594-1.361.594-2.478v-.872c0-.663-.072-1.187-.198-1.588a2.638 2.638 0 0 0-.647-1.064 2.947 2.947 0 0 0-1.115-.646c-.431-.122-.97-.192-1.636-.192Zm-.485 5.287h-7.299v-2.722h7.299c.413 0 .701.07.845.192.144.122.233.35.233.68v.978c0 .349-.09.575-.233.698-.144.122-.432.174-.845.174Z"
        fill="#fff"
      />
      <path d="M25.164 10.88a1.94 1.94 0 1 0 0-3.88 1.94 1.94 0 0 0 0 3.88Z" fill="#F41240" />
    </g>
    <defs>
      <clipPath id="rutube_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)
